import React, { useState } from 'react';
function TextFieldValidator({ index, initialInput, onGetErrorMsg, onGetInput, isRedFlagFromParent }) {
    const [textValue, setTextValue] = useState(' ');
    const [isInvalidated, setInvalidation] = useState('');

    const [isLikelyNotEnglish, setIsLikelyNotEnglish] = useState(false);
    const handleNoneEnglish = (inputText) => {
        // Regular expression to check for non-English alphabet characters
        const nonEnglishRegex = /[^a-zA-Z0-9]/;// /[^a-zA-Z\s.,?!'"`()\[\]{}<>\\\/+-=\d]/;
        setIsLikelyNotEnglish(nonEnglishRegex.test(inputText));
    }
    const handleFocus = () => { setTextValue(''); };
    const handleChange = (inputText) => {
        const input = inputText.target.value;
        handleNoneEnglish(input);

        let errorMessage = '';
        if (isLikelyNotEnglish)
            errorMessage = 'Please enter English Letter or Digit.';

        const capitalLetter = input.toUpperCase();
        setTextValue(capitalLetter);
        onGetInput(index, capitalLetter);
        setInvalidation(errorMessage !== '' ? true : false);

        if (onGetErrorMsg && errorMessage !== '')
            onGetErrorMsg(index, errorMessage);
        else
            onGetErrorMsg(index, '');
    };

    return (
        <div>
            <input
                type="text"
                value={textValue !== ' ' ? textValue : initialInput}
                onChange={handleChange}
                onFocus={handleFocus}
                onBlur={handleChange}

                maxLength="1"
                style={{
                    marginRight: '8px', padding: '8px', borderRadius: '4px', border: '1px solid #ccc',
                    backgroundColor: (isRedFlagFromParent || isInvalidated) ? '#ffe1da' : 'white',
                    color: (isRedFlagFromParent || isInvalidated) ? 'red' : 'black',
                    width: '28px',
                    height: '40px',
                    textAlign: 'center'
                }}
            />
        </div>
    );
};
export default TextFieldValidator;